import React, { FC, ReactNode, useEffect, useState } from 'react';
import { ToggleButton, ToggleButtonGroup, ToggleButtonProps } from '@mui/material';

import { useTranslate } from 'src/shared/providers';
import './SwitchButtons.styles.scss';

interface Props extends Pick<ToggleButtonProps, 'disabled'> {
  toggle: boolean;
  onToggle: (value: boolean) => void;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  disabled?: boolean;
  className?: string;
}

export const SwitchButtons: FC<Props> = ({
  toggle: toggleProp,
  onToggle,
  leftContent,
  rightContent,
  className = '',
  ...restProps
}) => {
  const { t } = useTranslate();
  const [toggle, setToggle] = useState<boolean>(toggleProp);

  useEffect(() => {
    if (toggleProp === toggle) {
      return;
    }

    setToggle(toggleProp);
  }, [toggleProp]);

  const handleChange = (newToggle: boolean | null) => {
    if (newToggle === null) {
      return;
    }

    onToggle(newToggle);
    setToggle(newToggle);
  };

  return (
    <ToggleButtonGroup
      {...restProps}
      className={`switch-wrapper ${className}`}
      exclusive
      value={toggle}
      onChange={(_, newToggle) => handleChange(newToggle)}
    >
      <ToggleButton value={true}>{leftContent || t('global.on')}</ToggleButton>
      <ToggleButton value={false}>{rightContent || t('global.off')}</ToggleButton>
    </ToggleButtonGroup>
  );
};
